export default "/_next/static/images/4078bb2e679a836de5f53e6c9450d1ae.jpg";